/*
 * Copyright (c) CJSC PETER-SERVICE, 2023.
 */
/**
 *
 *
 * @author Aleksandr Perkhunov
 * @author Andrey Dubov
 * @author Ilya Babanov
 * @author Ilya Baranchikov
 * @author Nikolay Sviridov
 * @author Denis Fedorov
 * @version 8.16.0
 * @since 1.0.0
 */

/**
 * Colors palette
 */
export const BrandColorMain = '#00b956';
export const BrandColorMainLighter = '#ebf9f1';
export const BrandColorMainHover = '#10e272';
export const BrandColorMainDarken = '#01873f';
export const BrandColorMainLighten = '#14cd6a';
export const BrandSecondaryColor = '#731982';
export const LightSoftBrandColor = '#ddffec';
export const BrandSoftSecondaryColor = '#aa67c1';

// new colors version 8.16.0
export const Green80 = '#0cdc78';
export const Green20 = '#ddffec';
export const BrandPurple80 = '#a367c1';
export const Purple20 = '#f2e5ff';
export const Night80 = '#4b83bb';
export const Night20 = '#d2e0ee';
export const Night = '#1e64aa';
export const Sky80 = '#63c7ff';
export const Sky20 = '#d8f1ff';
export const Sky = '#3cb9ff';
export const Flamingo80 = '#eb70eb';
export const Flamingo20 = '#fadbfa';
export const Flamingo = '#e64de6';
export const Lime80 = '#caff60';
export const Lime20 = '#e7ffb7';
export const Lime = '#af0';
export const Berry80 = '#bb7bff';
export const Berry20 = '#eedeff';
export const Berry = '#aa5aff';
export const Color137C80 = '#ffb945';
export const Color137C20 = '#ffedd1';
export const Fury80 = '#f8505d';
export const Fury20 = '#ffc5c9';
export const Background = '#fff';
export const ButtonHoverGreenSoft = '#b6ffda';
export const ButtonHoverPurpleSoft = '#ffd9ff';
export const ButtonHoverGrey = '#d6d6d6';
export const Overlay = '#000000cc';
export const STCWhite5 = '#ffffff0d';
export const STCWhite10 = '#ffffff1a';
export const STCWhite20 = '#ffffff33';
export const STCWhite50 = '#ffffff80';
export const STCBlack5 = '#3333330d';
export const STCBlack10 = '#3333331a';
export const STCBlack20 = '#33333333';
export const STCBlack50 = '#33333380';
export const STCWhite = '#fff';
export const STCBlack = '#333';
export const SystemBlue = '#34aaf2';

// new gradients
export const GradientGreen1 = 'linear-gradient(45deg, #00b956 50%, #af0)';
export const GradientGreen2 = 'linear-gradient(45deg, #00b956 50%, #1efa64)';
export const GradientGreen3 = 'linear-gradient(45deg, #00b956 50%, #00d1ff)';
export const GradientPurple1 = 'linear-gradient(45deg, #731982 50%, #aa5aff)';
export const GradientPurple2 = 'linear-gradient(45deg, #731982 50%, #e64de6)';
export const GradientPurple3 = 'linear-gradient(45deg, #731982 50%, #00d2ff)';
export const GradientPurple4 = 'linear-gradient(45deg, #731982 50%, #1b61ac)';
export const GradientLime = 'linear-gradient(45deg, #af0 50%, #00d1ff)';
export const GradientGrass = 'linear-gradient(45deg, #1efa64 50%, #00d1ff)';
export const GradientBerry1 = 'linear-gradient(45deg, #aa5aff 50%, #00d1ff)';
export const GradientBerry2 = 'linear-gradient(45deg, #aa5aff 50%, #e64de6)';
export const GradientScrim = 'linear-gradient(270deg, hsla(0, 0%, 100%, 0), #fff 20%)';

export const ColorError = '#f62434';
export const ColorWarning = '#ffa717';
export const ColorLink = '#34aaf2';
export const ColorGreenDark = '#404d46';
export const ColorGreenLight = '#59ffa7';

export const ColorGrey1 = '#333333';
export const ColorGrey2 = '#404d46';
export const ColorGrey3 = '#b2b2b2';
export const ColorGrey4 = '#f6f6f6';
export const ColorGrey5 = '#fafafa';
export const ColorGrey6 = '#f9f9f9';
export const ColorGrey7 = '#ccc';
export const ColorGreyLight1 = '#d8d8d8';
export const ColorGreyLight2 = '#ededed';
export const ColorWhite = '#ffffff'; // Base

export const _137C = '#ffa717';
export const _311C = '#5bd9e5';
export const Aquamarine = '#08d6a1';
export const Azure = '#00a2ff';
export const BlueBlue = '#1c53cd';
export const SoftBlue = '#6CC7ff';
export const ButtonDown = '#404d46';
export const LightSoftGreen = '#ddffec';
export const ButtonHoverGreen = '#10e272';
export const ButtonHoverPurple = '#a500bf';
export const ClearWhite = '#ffffff';
export const DarkPeach = '#d79159';
export const FreshAsphalt = '#333333'; // Content
export const FreshAsphalt50 = 'rgba(51, 51, 51, 0.5)';
export const FullBlack = '#000000';
export const Fury = '#f62434';
export const LightFury = '#f8505d';
export const LightFury80 = '#f8505d';
export const Green = '#00b956';
export const Link = '#34aaf2';
export const NiceBlue = '#128ab2';
export const LightBlue = '#e1faff';
export const Purple = '#731982';
export const LightPurple = '#ffeeff';
export const PurplePink = '#ac31c1';
export const BrandPurple = '#aa67c1';
export const PurpleRed = '#5b1168';
export const PurpleLight = '#821e93';
export const ReflexBlue = '#444189';
export const Salmon = '#ff6d6d';
export const SpbSky0 = '#f6f6f6';
export const SpbSky050 = '#fbfbfb';
export const SpbSky1 = '#ededed';
export const SpbSky150 = '#f6f6f6';
export const SpbSky2 = '#d8d8d8';
export const SpbSky3 = '#999999';
export const SunflowerYellow = '#ffd700';
export const Tangerine = '#ff8800';
export const WarmPink = '#ef476f';
export const WarmRedC = '#eb5a40';

/**
 * Border color
 */
export const borderColorDefault = ColorGreyLight1;
export const borderColorDisabled = ColorGreyLight2;
export const borderColorDown = ColorGrey2;
export const borderColorError = ColorError;
export const borderColorHover = BrandColorMainHover;
export const borderColorLight = ColorGreyLight1;
export const borderColorNormal = ColorGrey1;
export const borderColorSeparate = '#E5E5E5';
export const borderColorSeparateLight = ColorGrey6;
export const borderColorSuccess = BrandColorMain;
export const borderColorWarning = ColorWarning;
export const borderColorFocus = ColorGrey1;
/**
 * Background color
 */
export const backgroundColorBlack = FullBlack;
export const backgroundColorDisabled = ColorGreyLight2;
export const backgroundColorDisabledDark = ColorGreyLight1;
export const backgroundColorDown = ColorGrey2;
export const backgroundColorError = ColorError;
export const backgroundColorHover = BrandColorMainHover;
export const backgroundColorHoverGreen = ButtonHoverGreen;
export const backgroundColorHoverNormal = ColorGreyLight2;
export const backgroundColorHoverOpacity = SpbSky150;
export const backgroundColorModal = ColorGrey4;
export const backgroundColorNormal = ColorGrey1;
export const backgroundColorSuccess = BrandColorMain;
export const backgroundColorSuccessLighter = BrandColorMainLighter;
export const backgroundColorWarning = ColorWarning;
export const backgroundColorAlert = LightFury;
export const backgroundColorWhite = ColorWhite;
export const backgroundColorNoticeInfo = LightBlue;
export const backgroundColorGradientStart = BrandColorMainDarken;
export const backgroundColorGradientMiddle = BrandColorMain;
export const backgroundColorGradientEnd = BrandColorMainLighten;
export const backgroundToggleColorHover = ButtonHoverGreen;
export const backgroundIconColor = FullBlack;
export const backgroundProgressInactiveColor = ColorGreyLight2;
export const backgroundRangePickerInactiveColor = Purple;
export const backgroundInfoIconAlertColor = _311C;
export const backgroundPieTimeCharges = ColorLink;
export const backgroundPieMacroRegion = ReflexBlue;
export const backgroundPieMacroRegionAndNotInHomeRegion = _311C;

/**
 * Text color
 */
export const textAuthCollapseColor = FreshAsphalt;
export const textColor = ColorGrey1;
export const textColorActive = ColorGrey1;
export const textColorDanger = ColorError;
export const textColorOpacity = FreshAsphalt50;
export const textColorSuccess = BrandColorMain;
export const textColorWarning = WarmRedC;
export const textColorWhite = ColorWhite;
export const textDisabledColor = ColorGrey1;
export const textFocusColor = ColorGrey1;
export const textLabelColor = ColorGrey1;
export const textLinkColor = ColorLink;
export const textInputLabelDefaultColor = SpbSky3;
export const textInputLabelDisableColor = SpbSky3;
export const textInputValueDefaultColor = FullBlack;
/**
 * Button colors
 */
export const buttonPrimaryBackgroundColor = BrandColorMain;
export const buttonPrimaryBackgroundDisabled = SpbSky1;
export const buttonPrimaryTextColorDisabled = SpbSky3;
export const buttonPrimaryBorderColorDisabled = SpbSky3;
export const buttonOutlineBorderColorDisabled = SpbSky3;
export const buttonOutlineTextColorDisabled = SpbSky3;

/**
 * DChat colors
 */
export const chatErrorBackgroundColor = DarkPeach;
export const chatClientBackGround = LightSoftGreen;
export const chatBackgroundHoverColor = ButtonHoverGreen;
export const chatBackgroundActiveColor = ColorGreenDark;

/**
 * Header colors
 */
export const headerBackgroundColorStart = backgroundColorGradientStart;
export const headerBackgroundColorMiddle = backgroundColorGradientMiddle;
export const headerBackgroundColorEnd = backgroundColorGradientEnd;
export const headerDividerColor = borderColorLight;
export const headerDividerBorder = '1px';
export const headerTextColor = textColorWhite;
export const headerTextOpacity = 0.8;
export const headerTextHoverColor = textColorWhite;
export const headerBorderColor = textColorWhite;

export default {
    backgroundColorBlack,
    backgroundColorDisabled,
    backgroundColorDisabledDark,
    backgroundColorDown,
    backgroundColorError,
    backgroundColorHover,
    backgroundColorHoverGreen,
    backgroundColorHoverNormal,
    backgroundColorHoverOpacity,
    backgroundColorModal,
    backgroundColorNormal,
    backgroundColorNoticeInfo,
    backgroundColorSuccess,
    backgroundColorSuccessLighter,
    backgroundColorWarning,
    backgroundColorAlert,
    backgroundColorWhite,
    backgroundColorGradientStart,
    backgroundColorGradientMiddle,
    backgroundColorGradientEnd,
    backgroundProgressInactiveColor,
    backgroundRangePickerInactiveColor,
    backgroundInfoIconAlertColor,
    backgroundPieTimeCharges,
    backgroundPieMacroRegion,
    backgroundPieMacroRegionAndNotInHomeRegion,
    borderColorDefault,
    borderColorDisabled,
    borderColorDown,
    borderColorError,
    borderColorHover,
    borderColorLight,
    borderColorNormal,
    borderColorSeparate,
    borderColorSeparateLight,
    borderColorSuccess,
    borderColorWarning,
    textAuthCollapseColor,
    textColor,
    textColorActive,
    textColorDanger,
    textColorOpacity,
    textColorSuccess,
    textColorWarning,
    textColorWhite,
    textDisabledColor,
    textFocusColor,
    textLabelColor,
    textLinkColor,
    textInputLabelDefaultColor,
    textInputLabelDisableColor,
    textInputValueDefaultColor,
    borderColorFocus,
    buttonPrimaryBackgroundColor,
    buttonPrimaryBackgroundDisabled,
    buttonPrimaryTextColorDisabled,
    buttonPrimaryBorderColorDisabled,
    buttonOutlineBorderColorDisabled,
    buttonOutlineTextColorDisabled,
    backgroundToggleColorHover,
    BrandSecondaryColor,
    BrandSoftSecondaryColor,
    backgroundIconColor,
    chatClientBackGround,
    chatBackgroundActiveColor,
    chatErrorBackgroundColor,
    chatBackgroundHoverColor,
    LightSoftBrandColor,
    headerBackgroundColorStart,
    headerBackgroundColorMiddle,
    headerBackgroundColorEnd,
    headerDividerColor,
    headerDividerBorder,
    headerTextColor,
    headerTextOpacity,
    headerTextHoverColor,
    headerBorderColor,
};
